import { ActionBase } from '../../../../core/store/action/ActionBase';

export function getSelectionType<TModel>(module: string, type: { new(): TModel;}):string
{
  return `[${module}] Get Selection ${(type as any).$typeName}`;
}

export class GetSelectionAction<TModel> implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { key: string, subKey?: string } | any) {
    this.type = getSelectionType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/GetSelectionAction.ts